import { connectHook } from 'app/common/components/connect-hook';
import { CodeBlock } from './code-block';
import { useCodeBlock } from './code-block-hook';

export default connectHook(CodeBlock, useCodeBlock);
